// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiTypography-root.header-typography-normal {
	font-family: 'Open Sans', sans-serif;
	font-size: 27px;
	font-style: normal;
	line-height: 1;
	letter-spacing: -0.54px;
	display: flex;
	align-items: center;
	height: 40px;
	font-weight: 400;
}
`, "",{"version":3,"sources":["webpack://./src/components/LogoAndProductName/LogoAndProductName.css"],"names":[],"mappings":"AAAA;CACC,oCAAoC;CACpC,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,uBAAuB;CACvB,aAAa;CACb,mBAAmB;CACnB,YAAY;CACZ,gBAAgB;AACjB","sourcesContent":[".MuiTypography-root.header-typography-normal {\n\tfont-family: 'Open Sans', sans-serif;\n\tfont-size: 27px;\n\tfont-style: normal;\n\tline-height: 1;\n\tletter-spacing: -0.54px;\n\tdisplay: flex;\n\talign-items: center;\n\theight: 40px;\n\tfont-weight: 400;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
